import { customerRoutes } from 'noddi-util';

export type CustomerTimePickerSurface = 'mobile' | 'stationary';

const pathPattern = (template: string) =>
  new RegExp(`^${template.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/:[^/]+/g, '[^/]+')}$`);

const exactPath = (path: string) => pathPattern(path);

const slugPath = (pathWithSlug: string) => pathPattern(pathWithSlug.replace('__slug__', ':slug'));

/**
 * Known picker routes. The shared edit URL is not here: that page publishes
 * mobile or stationary itself, because one path serves both flows.
 */
const PICKER_ROUTES: { surface: CustomerTimePickerSurface; pattern: RegExp }[] = [
  { surface: 'mobile', pattern: exactPath(customerRoutes.newBookingTimeWindow.getPath()) },
  {
    surface: 'mobile',
    pattern: slugPath(customerRoutes.bookingProposalTimeWindowPicker.getPath({ slug: '__slug__' }))
  },
  {
    surface: 'stationary',
    pattern: slugPath(customerRoutes.stationaryProposalTimeWindow.getPath({ slug: '__slug__' }))
  },
  { surface: 'stationary', pattern: exactPath(customerRoutes.newStationaryBookingTimeWindow.getPath()) }
];

const EDIT_TIME_WINDOW = pathPattern(customerRoutes.editMyBookingTimeWindow.getBasePath());

/** Which customer time picker this URL is, before a page has published one. */
export const customerTimePickerSurfaceFromPath = (pathname: string): CustomerTimePickerSurface | null =>
  PICKER_ROUTES.find((route) => route.pattern.test(pathname))?.surface ?? null;

/**
 * The route map wins on a known picker. The published surface is only for the
 * edit-booking URL, which is one path for both flows.
 */
export const resolveCustomerTimePickerSurface = (
  pathname: string,
  published: CustomerTimePickerSurface | null
): CustomerTimePickerSurface | null => {
  const fromPath = customerTimePickerSurfaceFromPath(pathname);
  if (fromPath) {
    return fromPath;
  }
  if (EDIT_TIME_WINDOW.test(pathname)) {
    return published;
  }
  return null;
};

export const noticeMatchesTimePicker = (
  notice: { showOnMobileTimePicker: boolean; showOnStationaryTimePicker: boolean },
  surface: CustomerTimePickerSurface
) => (surface === 'mobile' ? notice.showOnMobileTimePicker : notice.showOnStationaryTimePicker);
